var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 3.85714V2.14286C4.8 1.51167 5.27756 1 5.86667 1H10.1333C10.7224 1 11.2 1.51167 11.2 2.14286V3.85714M0 4.42857H16M1.6 4.42857V15.8571C1.6 16.4883 2.07756 17 2.66667 17H13.3333C13.9224 17 14.4 16.4883 14.4 15.8571V4.42857M8 8.42857V14.1429M4.8 10.7143V14.1429M11.2 10.7143V14.1429",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1f710af017012458ec24d82d5610b33f.svg";
export { ForwardRef as ReactComponent };